const EmailIcon = () => {
  return (
    <svg
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42 9.4082H6C5.60218 9.4082 5.22064 9.56624 4.93934 9.84754C4.65804 10.1288 4.5 10.5104 4.5 10.9082V36.4082C4.5 37.2039 4.81607 37.9669 5.37868 38.5295C5.94129 39.0921 6.70435 39.4082 7.5 39.4082H40.5C41.2957 39.4082 42.0587 39.0921 42.6213 38.5295C43.1839 37.9669 43.5 37.2039 43.5 36.4082V10.9082C43.5 10.5104 43.342 10.1288 43.0607 9.84754C42.7794 9.56624 42.3978 9.4082 42 9.4082ZM38.1431 12.4082L24 25.3738L9.85687 12.4082H38.1431ZM40.5 36.4082H7.5V14.3188L22.9856 28.5145C23.2624 28.7685 23.6243 28.9094 24 28.9094C24.3757 28.9094 24.7376 28.7685 25.0144 28.5145L40.5 14.3188V36.4082Z"
        fill="#009C8F"
      />
    </svg>
  );
};

export default EmailIcon;
